import * as React from 'react';
import classnames from 'classnames';

import TimeUtils from 'common/utils/TimeUtils';

import { DayOfWeekType } from 'common/enums/DateTimeEnums';

import theme from './MandatoryDaysSummary.scss';

class MandatoryDaysSummary extends React.PureComponent {
    render() {
        const { mandatoryDays } = this.props;
        return (
            <div className={theme.dayOfWeekWrap}>
                {Object.values(DayOfWeekType).map(dayOfWeek => {
                    return (
                        <span
                            className={classnames(theme.dayOfWeek, {
                                [theme.isOptional]: !mandatoryDays.includes(
                                    dayOfWeek
                                )
                            })}
                            key={dayOfWeek}
                        >
                            {TimeUtils.getDayShortCode(dayOfWeek)}
                        </span>
                    );
                })}
            </div>
        );
    }
}

export default MandatoryDaysSummary;
